import React from "react";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";

export function CompetitorBlock(competitor) {
    //console.log(competitor)
    let seed = ''
    let competitorBracket;
    if (competitor.co_seed) {
        seed = '(' + competitor.co_seed + ')'
    }
    if (competitor?.participant?.__typename === 'Person') {
        competitorBracket = <div className="w-85"><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} /></div>
    } else {
        competitorBracket = <div className="w-85"><Competitor hidePicture={true} hideNoc={true} noLink={true} teamAthletes={competitor?.resultItem?.teamAthletes} /></div>
    }

    //Check if the game is singles or doubles

    return (
        <div className='score-competitor-container d-flex justify-content-start text-truncate'>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name d-flex align-items-center'>
                {competitorBracket}
                <span><sup>{seed}</sup></span>
            </div>
        </div>
    )
}
